export const BACKEND_URL = "https://sociopediabackend.rohithreddy.dev"